var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "card-link-wrapper", attrs: { href: _vm.item.Cta.Url } },
    [
      _c("div", { staticClass: "content-list-item" }, [
        _c("h2", { staticClass: "content-list-item-title" }, [
          _vm._v(_vm._s(_vm.item.Title))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-list-item-date" }, [
          _vm._v(_vm._s(_vm._f("formatDate")(_vm.item.Date)))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-list-item-summary" }, [
          _vm._v(_vm._s(_vm._f("decode")(_vm.item.Summary)))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-list-item-cta" }, [
          _c("div", { staticClass: "link" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.item.Cta.Text) +
                "\n            "
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }